/**
 * @generated SignedSource<<01557f4c7e281ebe910c293ca42db321>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_user$data = {
  readonly favorites?: {
    readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_favoritesConnection">;
  } | null;
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_user" | "PdpSharedMakeOfferButton_user" | "PdpSharedShoppingButtons_user">;
  readonly " $fragmentType": "PdpRespSidebarButtons_user";
};
export type PdpRespSidebarButtons_user$key = {
  readonly " $data"?: PdpRespSidebarButtons_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchFollowSearch"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user"
    },
    {
      "condition": "fetchFollowSearch",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "pages",
              "variableName": "followSearchPages"
            },
            {
              "kind": "Literal",
              "name": "types",
              "value": [
                "SEARCH",
                "USER_PREFERENCE"
              ]
            }
          ],
          "concreteType": "favoritesConnection",
          "kind": "LinkedField",
          "name": "favorites",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SaveSearchButton_favoritesConnection"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShoppingButtons_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7fdfcccfba3d0e71bf22fab8f5440eee";

export default node;
